export default "__VITE_ASSET__BlqPxSun__"